import { getDarkenColor, getLightenColor } from ".";

export default (type, colors) => {
  const styles = {
    default: {
      'badge': {
        background: getLightenColor(colors.secondary, 0.23),
        customCSS: `
          a.badge.badge--transparent, button.badge.badge--transparent {
            color: ${colors.primary};
          }
          .badge--white {
            background: #fff;
          }
        `
      },
      'badge-button': {
        customCSS: `
          .badge:not(a) {
            background: ${getLightenColor(colors.primary, 2)};
          }
          .badge:not(a):hover, 
          .badge:not(a):active, 
          .badge:not(a):focus {
            background: ${getDarkenColor(getLightenColor(colors.primary, 2),0.15)};
          }

          .badge:not(a).badge--transparent:active, 
          .badge:not(a).badge--transparent:focus, 
          .badge:not(a).badge--transparent:hover {
            background: #c4c4c4;
          }
        `
      },
      'badge-a': {
        customCSS: `
          .badge:not(button) {
            background: ${getLightenColor(colors.primary, 2)};
          }

          .badge:not(button).more-link,
          [data-article-style=item] .c-article__title .badge {
            background: ${colors.primary};
          }

          .badge:not(button).more-link:hover, 
          .badge:not(button).more-link:active, 
          .badge:not(button).more-link:focus {
            background: ${getDarkenColor(colors.secondary_dark,0.2)}!important;
          }

          .badge:not(button).more-link:hover,
          .badge:not(button).more-link:active,
          .badge:not(button).more-link:focus {
            background: ${getDarkenColor(colors.primary,0.15)};
          }
          .badge:not(button):hover,
          .badge:not(button):active,
          .badge:not(button):focus {
            background: ${getDarkenColor(getLightenColor(colors.primary, 2),0.15)};
          }

          .badge:not(button).badge--transparent:active, 
          .badge:not(button).badge--transparent:focus, 
          .badge:not(button).badge--transparent:hover {
            background: #c4c4c4;
          }
        `
      },
      'badge__close': {
        customCSS: `
          .badge__close:hover, 
          .badge__close:focus, 
          .badge__close:active {
            color: ${colors.light};
            background: ${colors.info};
          }
        `
      },
    },
    type1: {
      'badge': {
        padding: '0.4em 0.6em',
        maxWidth: '300px',
        marginBottom: '0.25em',
        background: getLightenColor(colors.secondary, 0.27),
        customCSS: `
          a.badge.badge--transparent, button.badge.badge--transparent {
            color: ${colors.primary};
            padding: 0;
          }
          .badge--white {
            background: #fff;
          }
        `
      },
      'badge-button': {
        customCSS: `
          .badge:not(a) {
            background: ${getLightenColor(colors.primary, 2)};
          }
          .badge:not(a):hover, 
          .badge:not(a):active, 
          .badge:not(a):focus {
            background: ${getDarkenColor(getLightenColor(colors.primary, 2),0.15)};
          }

          .badge:not(a).badge--transparent:active, 
          .badge:not(a).badge--transparent:focus, 
          .badge:not(a).badge--transparent:hover {
            background: #c4c4c4;
          }
        `
      },
      'badge-a': {
        customCSS: `
          .badge:not(button) {
            color: ${colors.light};
            background: ${colors.secondary};
            border-radius: 6px!important;
          }

          .badge:not(button).more-link,
          [data-article-style=item] .c-article__title .badge {
            background: ${colors.primary};
          }

          .badge:not(button).more-link:hover,
          .badge:not(button).more-link:active,
          .badge:not(button).more-link:focus {
            background: ${getDarkenColor(colors.primary,0.15)};
          }

          .badge:not(button):hover,
          .badge:not(button):active,
          .badge:not(button):focus {
            background: ${getDarkenColor(colors.secondary,0.15)};
          }

          .badge:not(button).badge--transparent:active, 
          .badge:not(button).badge--transparent:focus, 
          .badge:not(button).badge--transparent:hover {
            background: #c4c4c4;
          }
        `
      },
      'badge__content': {
        lineHeight: 'normal',
        padding: '0.6em 0',
        overflow: 'hidden',
        // maxHeight: '4.5em',
      },
      'badge__close': {
        top: 0,
        lineHeight: '11px',
        height: '1.2em',
        width: '1.2em',
        customCSS: `
          .badge__close:hover, 
          .badge__close:focus, 
          .badge__close:active {
            color: ${colors.light};
            background: ${colors.info};
          }
        `
      },
      'badge--closable': {
        customCSS: `
          .badge--closable .badge__content {
            height: auto;
            max-width: 90%;
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/badge.js